import React, { FC } from 'react';

import { Box, SxProps, Typography } from '@mui/material';

import { convertToDecimals, currency, perHour } from '@pharmaplan/common';
import { ChipType, SkeletonVariants } from '../../../helpers/Constants';

import WithSkeleton from '../WithSkeleton';
import CustomChip from '../CustomChip';
import styles from './styles';

interface IHourlyRateChipLabel {
  type: ChipType;
  rate?: number | undefined | string;
  successAction: string;
  label?: string;
  strikeRate?: number | string | null;
  customContainerStyle?: SxProps;
  customLabelStyle?: SxProps;
  customChip?: React.ReactNode;
}

const HourlyRateChipLabel: FC<IHourlyRateChipLabel> = ({
  type,
  rate,
  label,
  successAction,
  strikeRate,
  customLabelStyle,
  customContainerStyle,
  customChip,
}) => {
  const SkeletonTypography = WithSkeleton({
    successAction,
    variant: SkeletonVariants.text,
  })(Typography);

  const SkeletonBox = WithSkeleton({
    successAction,
    variant: SkeletonVariants.rounded,
  })(Box);

  return (
    <Box sx={[styles.itemContainer, customContainerStyle] as SxProps}>
      {!!label && (
        <SkeletonTypography sx={[styles.title, customLabelStyle] as SxProps}>
          {label}
        </SkeletonTypography>
      )}
      <SkeletonBox sx={styles.chip}>
        {strikeRate && (
          <Typography sx={styles.strikeRate}>
            {`${currency}${convertToDecimals(
              parseFloat((strikeRate as string) ?? '0'),
            )}${perHour}`}
          </Typography>
        )}
        {customChip ?? (
          <CustomChip
            type={type}
            label={`${currency}${convertToDecimals(
              parseFloat((rate as string) ?? '0'),
            )}${perHour}`}
          />
        )}
      </SkeletonBox>
    </Box>
  );
};

export default HourlyRateChipLabel;
